import Vue from 'vue'
import { library, dom } from '@fortawesome/fontawesome-svg-core'
import {
  faUserSecret,
  faUser,
  faHouseUser,
  faFileInvoiceDollar,
  faNotesMedical,
  faVirus,
  faAmbulance,
  faSyringe,
  faBandAid,
  faMedkit,
  faPills,
  faMortarPestle,
  faPumpSoap,
  faShoppingBasket,
  faShoppingCart,
  faHeartbeat,
  faBrain,
  faRadiation,
  faVial,
  faVials,
  faStethoscope,
  faUserMd,
  faSeedling,
  faTooth,
  faDrumstickBite,
  faUserNurse,
  faUserFriends,
  faUmbrella,
  faHospital,
  faAmericanSignLanguageInterpreting,
  faWalking,
  faCalendarAlt,
  faClipboardList,
  faUsers,
  faMapMarkedAlt,
  faBars,
  faGenderless,
  faFile,
  faLaptopMedical,
  faMoneyBillAlt,
  faSpinner,
  faExclamationTriangle,
  faCog,
  faExpand,
  faCompress,
  faPhoneSlash,
  faPhone,
  faVideo,
  faVideoSlash,
  faComments
} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

dom.watch()

library.add(
  faUserSecret,
  faUser,
  faHouseUser,
  faFileInvoiceDollar,
  faNotesMedical,
  faVirus,
  faAmbulance,
  faSyringe,
  faBandAid,
  faMedkit,
  faPills,
  faMortarPestle,
  faPumpSoap,
  faShoppingBasket,
  faShoppingCart,
  faHeartbeat,
  faBrain,
  faRadiation,
  faVial,
  faVials,
  faStethoscope,
  faUserMd,
  faSeedling,
  faTooth,
  faDrumstickBite,
  faUserNurse,
  faUserFriends,
  faUmbrella,
  faHospital,
  faAmericanSignLanguageInterpreting,
  faWalking,
  faCalendarAlt,
  faClipboardList,
  faUsers,
  faMapMarkedAlt,
  faBars,
  faGenderless,
  faFile,
  faLaptopMedical,
  faMoneyBillAlt,
  faSpinner,
  faExclamationTriangle,
  faCog,
  faExpand,
  faCompress,
  faPhoneSlash,
  faPhone,
  faVideo,
  faVideoSlash,
  faComments
)

Vue.component('font-awesome-icon', FontAwesomeIcon)
